import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FilteredUserTeamData } from '../models/common-data.model';

@Injectable({
  providedIn: 'root',
})
export class GlobalFilterService {
  constructor() {}

  private selectedTeamUserSource = new BehaviorSubject<
    FilteredUserTeamData[] | null
  >(null);

  private selectedPrivilegedUserIds = new BehaviorSubject<string[] | null>(
    null
  );

  setSelectedTeamUser(
    filteredUserTeamData: FilteredUserTeamData[] | null
  ): void {
    this.selectedTeamUserSource.next(filteredUserTeamData);
  }

  getSelectedTeamUser(): FilteredUserTeamData[] | null {
    return this.selectedTeamUserSource.getValue();
  }

  setSelectedPrivilegedUserIds(selectedPrivilegedUserIds: string[]): void {
    this.selectedPrivilegedUserIds.next(selectedPrivilegedUserIds);
  }

  getSelectedPrivilegedUserIds(): string[] | null {
    return this.selectedPrivilegedUserIds.getValue();
  }
}
